export default __webpack_public_path__ + "static/media/5_B8M52J_ok-min.8cadb345.jpg";